module.exports = __webpack_public_path__ + "static/media/Drone.d4ce144e.svg";